// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fa839034","281":"1878f590"}[chunkId] + ".chunk.js";
};